var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.8613 19.861C24.254 15.4682 24.254 8.34621 19.8613 3.95348C15.4685 -0.439259 8.34648 -0.439258 3.95375 3.95348C-0.438985 8.34621 -0.438985 15.4682 3.95375 19.861C8.34648 24.2537 15.4685 24.2537 19.8613 19.861Z",
    fill: "url(#paint0_linear_1719_13923)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0878 13.9087C22.2873 18.5924 18.5918 22.2877 13.9082 23.0883L7.85191 17.032C6.40268 15.836 5.479 14.026 5.479 12.0002C5.479 8.39887 8.39838 5.47949 11.9997 5.47949C14.0255 5.47949 15.8355 6.40321 17.0315 7.8524L23.0878 13.9087Z",
    fill: "#004F9C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.94752 12.3874L10.8046 14.0928C11.0755 14.3422 11.4948 14.3289 11.7496 14.0662L15.0626 10.8942C15.3321 10.635 15.3403 10.2063 15.0811 9.9367C14.8218 9.66749 14.3934 9.65905 14.1239 9.91818L11.2541 12.6659L9.86496 11.3902C9.58975 11.137 9.16099 11.1548 8.90763 11.4303C8.65432 11.7055 8.67218 12.134 8.94752 12.3874ZM11.9997 5.47949C15.6011 5.47949 18.5205 8.39887 18.5205 12.0002C18.5205 15.6016 15.6011 18.521 11.9997 18.521C8.39838 18.521 5.479 15.6016 5.479 12.0002C5.479 8.39887 8.39838 5.47949 11.9997 5.47949Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1719_13923",
    x1: 3.95375,
    y1: 19.861,
    x2: 19.8612,
    y2: 3.95347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0060BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04AEED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPass);
export default __webpack_public_path__ + "static/media/pass.476df69badcc961d7a33aba50277b2f9.svg";
export { ForwardRef as ReactComponent };